import Media from 'react-media';
import { mediaQueries } from '@eti/styles';
import { Illustration, Pictogram } from '@eti/components';
import { useSiteContext } from '@eti/providers';
import { getProductIllustrationId, getProductPictogramId } from '../../../common/utils/icon/getProductImageryIds';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const BaggageIllustration = _ref => {
  let {
    productName,
    isRTL
  } = _ref;
  const {
    brand: {
      code: brand
    }
  } = useSiteContext();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Media, {
      query: mediaQueries.medium.up,
      children: matches => {
        var _getProductIllustrati;
        return matches && /*#__PURE__*/_jsx(Illustration, {
          brand: brand,
          "data-testid": `${productName}-illustration`,
          id: (_getProductIllustrati = getProductIllustrationId(productName, isRTL)) !== null && _getProductIllustrati !== void 0 ? _getProductIllustrati : getProductPictogramId('fallback', isRTL)
        });
      }
    }), /*#__PURE__*/_jsx(Media, {
      query: mediaQueries.small.only,
      children: matches => {
        var _getProductPictogramI;
        return matches && /*#__PURE__*/_jsx(Pictogram, {
          brand: brand,
          "data-testid": `${productName}-pictogram`,
          id: (_getProductPictogramI = getProductPictogramId(productName, isRTL)) !== null && _getProductPictogramI !== void 0 ? _getProductPictogramI : getProductPictogramId('fallback', isRTL)
        });
      }
    })]
  });
};
export default BaggageIllustration;
//# sourceMappingURL=BaggageIllustration.js.map